exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".team-icon-1{fill:none}.team-icon-2{fill:#d2dbe1}.team-icon-3{fill:#fff}.team-icon-4{fill:#f7caa5}.team-icon-5{fill:#faedb1}.team-icon-6{fill:#ee7470;opacity:.5;isolation:isolate}.team-icon-7{fill:#bfe7e3}.team-icon-8{fill:#1e4e69}\n", ""]);
